// @flow
import * as constants from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const defaultState = fromJS({
    data: null
});

const actionHandlers = {
    [constants.AUDIO_DATA_RECEIVED]: handleReduce((state, { payload: { data } }) => state.set('data', data)),
    [constants.CLEAR_DATA]: handleReduce(state => state.set('data', null))
};

export default handleActions(actionHandlers, defaultState);



// WEBPACK FOOTER //
// ./src/core/state/ui/sensor-logs/audio-player/index.js